// src/components/dashboard/DashboardCards.js
import React from 'react';
import { Clock, Target, Zap, Star, TrendingUp, Calendar } from 'lucide-react';

const DashboardCards = ({ dashboardData }) => {
  if (!dashboardData) return null;

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    if (hours > 0) return `${hours}h ${minutes}m`;
    return `${minutes}m`;
  };

  const formatTimeFromSeconds = (seconds) => {
    return formatTime(seconds);
  };

    const cards = [
    {
        title: 'Learning Streak',
        value: `${dashboardData.learningStreak} days`,
        icon: <Calendar className="w-8 h-8" />,
        color: 'from-orange-400 to-red-500',
        description: 'Consecutive days playing'
    },
    {
        title: 'Total Play Time',
        value: formatTimeFromSeconds(dashboardData.totalPlayTime), // Changed this
        icon: <Clock className="w-8 h-8" />,
        color: 'from-blue-400 to-blue-600',
        description: 'All time learning'
    },
    {
        title: 'Overall Accuracy',
        value: `${dashboardData.overallAccuracy}%`,
        icon: <Target className="w-8 h-8" />,
        color: 'from-green-400 to-green-600',
        description: 'Correct answers'
    },
    {
        title: 'Total Sessions',
        value: dashboardData.sessionsCount,
        icon: <Zap className="w-8 h-8" />,
        color: 'from-purple-400 to-purple-600',
        description: 'Games completed'
    },
    {
    title: 'This Week',
    value: formatTimeFromSeconds(dashboardData.last7DaysTime), // Fixed - no division
    icon: <TrendingUp className="w-8 h-8" />,
    color: 'from-pink-400 to-pink-600',
    description: 'Last 7 days'
    },
    {
        title: 'Total Score',
        value: dashboardData.totalScore?.toLocaleString() || '0',
        icon: <Star className="w-8 h-8" />,
        color: 'from-yellow-400 to-yellow-600',
        description: 'Points earned'
    }
    ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
      {cards.map((card, index) => (
        <div
          key={index}
          className={`bg-gradient-to-br ${card.color} rounded-2xl p-6 text-white shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300`}
        >
          <div className="flex items-center justify-between mb-4">
            <div className="bg-white/20 rounded-xl p-3 backdrop-blur-sm">
              {card.icon}
            </div>
            <div className="text-right">
              <div className="text-2xl md:text-3xl font-bold">{card.value}</div>
              <div className="text-white/80 text-sm">{card.description}</div>
            </div>
          </div>
          <h3 className="text-lg font-semibold">{card.title}</h3>
        </div>
      ))}
    </div>
  );
};

export default DashboardCards;